import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import ChapterListItem from 'components/ChapterListItem';
import SearchResultSingleListItem from '../SearchResultSingleListItem';
import { Typography } from '@redshelf/redshelf-ui';

const useStyles = makeStyles((theme) => {
  return {
    titleText: {
      color: theme.palette.greyBlue['900'],
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(1.5),
      paddingLeft: 0,
    },
  };
});

const SearchResultListItem = ({
  isMobile,
  onClose,
  searchResultGroup,
  onSuccessfulNavigateToSearchResult,
  ...props
}) => {
  const classes = useStyles();

  const id = `search-chapter-dropdown-${searchResultGroup.marker.index}`;

  const chapterTitle = (
    <Typography
      className={`${classes.titleText} noTranslate`}
      component="h3"
      variant="body2"
    >
      {searchResultGroup.marker.label} (
      {searchResultGroup.searchResultItems.length})
    </Typography>
  );

  return (
    <ChapterListItem
      ariaLabelChapterTitle={searchResultGroup.marker.label}
      title={chapterTitle}
      id={id}
      isNavItem={false}
      {...props}
    >
      {searchResultGroup.searchResultItems.map((singleSearchResult, index) => (
        <SearchResultSingleListItem
          key={`${singleSearchResult.key}-in-marker-${searchResultGroup.marker.index}-index-${index}`}
          singleSearchResult={singleSearchResult}
          isMobile={isMobile}
          onClose={onClose}
          onSuccessfulNavigateToSearchResult={
            onSuccessfulNavigateToSearchResult
          }
        />
      ))}
    </ChapterListItem>
  );
};

SearchResultListItem.propTypes = {
  isMobile: PropTypes.bool,
  onClose: PropTypes.func,
  singleSearchResult: PropTypes.object,
  onSuccessfulNavigateToSearchResult: PropTypes.func,
};

export default SearchResultListItem;
